import { Component, EventEmitter, HostBinding, Output, input } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {

  readonly display = input(false);
  @Output() displayChange = new EventEmitter<boolean>();

  @HostBinding('class') get classes(): string {
    return this.display() ? 'modal is-active' : 'modal';
  }

  close(event$: Event): void {
    event$.stopPropagation();
    this.displayChange.emit(false);
  }

}
